<template>
  <section class="two-factor ine-form">
    <div class="ine-form__background">
      <img class="ine-form__logo" src="@/assets/images/home-logo.png" />
    </div>
    <div class="ine-form__form-wrapper">
      <form @submit.prevent="validateForm" class="ine-form__form">
        <div class="ine-form__title-wrapper">
          <h4 class="ine-form__welcome">Two Factor Confirmation</h4>
          <p class="ine-form__lead-in">
            You should receive an email shortly which contains an 'MFA Code'.
            <br />
            Please enter that code in the form below to continue logging in.
          </p>
        </div>
        <div class="ine-form__form-group">
          <input
            type="text"
            class="ine-form__form-control"
            placeholder="MFA code.."
            v-model="code"
          />
        </div>
        <div class="ine-form__submit-btn-wrapper">
          <button
            class="ine-form__submit-btn btn__auth"
            type="submit"
            v-show="!loading"
          >
            Submit
            <span class="material-icons btn__auth--icon">security</span>
          </button>
          <ClipLoader
            v-show="loading"
            :size="1.5"
            sizeUnit="rem"
            class="ine-form__loading-spinner"
          ></ClipLoader>
        </div>
        <div v-show="!loading" class="login__additional-links-wrapper">
          <button
            @click.prevent="resendMFACode()"
            class="ine-form__additional-link"
          >
            Resend Code
          </button>
        </div>
        <div
          v-show="!loading"
          class="ine-form__additional-links-wrapper ine-form__homepage-link"
        >
          <button
            @click.prevent="cancelLogin()"
            class="ine-form__additional-link"
          >
            Back to Homepage
          </button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { ClipLoader } from '@saeris/vue-spinners'
import { getToken, clearToken } from '@/helpers'

export default {
  name: 'TwoFactor',
  components: {
    ClipLoader,
  },
  data() {
    return {
      code: '',
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      isTwoFactorRequired: 'auth/isTwoFactorRequired',
      searchQuery: 'search/searchQuery',
      memberId: 'auth/memberId',
      userId: 'auth/userId',
      redirectUrl: 'auth/redirectUrl',
    }),
  },
  methods: {
    async resendMFACode() {
      this.loading = true
      await this.$store.dispatch('auth/resendMFACode')
      this.$store.dispatch(
        'app/setError',
        'The code has been sent to your email.'
      )
      this.loading = false
    },
    validateForm() {
      if (!this.code.length) {
        this.$store.dispatch('app/setError', 'Please enter the code.')
        return
      }
      this.submitCode()
    },
    async submitCode() {
      this.loading = true
      await this.$store.dispatch('auth/submitMFACode', this.code)
      if (this.isAuthenticated) {
        window.dataLayer.push({
          event: 'start_pw',
          pw_user_email: this.email,
        })
        if (this.redirectUrl && this.redirectUrl.length) {
          window.location.replace(this.redirectUrl)
        } else {
          this.$router.push({ name: 'home' })
        }
      } else {
        this.loading = false
      }
    },
    cancelLogin() {
      clearToken()
      this.$store.dispatch('auth/setIsTwoFactorRequired', false)
      this.$store.dispatch('auth/setRedirectUrl', '')
      this.$router.push({ name: 'home' })
    },
  },
  async created() {
    const token = await getToken()
    if (!this.isTwoFactorRequired || !token) {
      this.$router.push({ name: 'login' })
      this.$store.dispatch('auth/setIsTwoFactorRequired', false)
    }
    this.$store.dispatch('app/setIsPageLoading', false)
  },
}
</script>

<style lang="scss" scoped>
.two-factor {
  .ine-form__lead-in {
    font-size: 1rem;
  }
  .btn__auth {
    padding: 7px 15px;
    &--icon {
      font-size: 1.5rem;
    }
  }
}
</style>
